const practices = [
  {
    id: 'architecture',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20clean%20architecture%20layers%20stacked%20translucent%20geometric%20planes%20in%20warm%20teal%20and%20gray%20tones%20minimal%20composition%20soft%20ambient%20light%20editorial%20product%20photography%20no%20text%20no%20people%20pure%20abstract&width=600&height=400&seq=solution-card-01&orientation=landscape',
    label: 'System Architecture',
    description: 'Designing scalable foundations that support long-term growth and adaptability across evolving technical landscapes.',
    featured: true,
  },
  {
    id: 'performance',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20performance%20metrics%20visualization%20flowing%20geometric%20ribbons%20in%20soft%20coral%20and%20cream%20minimal%20elegant%20composition%20clean%20aesthetic%20no%20text%20no%20people%20pure%20abstract%20editorial%20quality&width=600&height=400&seq=solution-card-02&orientation=landscape',
    label: 'Performance Engineering',
    description: 'Optimizing systems for speed, efficiency, and resource-conscious operation under real-world conditions.',
    featured: false,
  },
  {
    id: 'quality',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20quality%20patterns%20interlocking%20geometric%20shapes%20in%20warm%20sage%20and%20gray%20minimal%20precise%20composition%20soft%20diffused%20lighting%20no%20text%20no%20people%20pure%20abstract%20high%20detail&width=600&height=400&seq=solution-card-03&orientation=landscape',
    label: 'Quality Engineering',
    description: 'Ensuring reliability through structured testing, validation processes, and continuous quality monitoring.',
    featured: false,
  },
  {
    id: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20innovation%20pathways%20ascending%20geometric%20forms%20in%20warm%20amber%20and%20teal%20clean%20minimal%20composition%20editorial%20quality%20no%20text%20no%20people%20pure%20abstract%20visualization&width=600&height=400&seq=solution-card-04&orientation=landscape',
    label: 'Technical Strategy',
    description: 'Guiding technology decisions with engineering-first principles and a long-term perspective on system evolution.',
    featured: false,
  },
];

export default function SolutionsSection() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28 px-4 md:px-6">
      <div className="w-full max-w-[1200px] mx-auto">
        <h2 className="text-center text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-16 md:mb-20">
          Areas of Practice
        </h2>
      </div>

      <div className="w-full overflow-x-auto pb-4" style={{ scrollbarWidth: 'thin' }}>
        <div className="flex gap-5 px-4 md:px-6" style={{ minWidth: 'max-content', paddingLeft: 'max(1rem, calc((100vw - 1200px) / 2 + 1rem))', paddingRight: 'max(1rem, calc((100vw - 1200px) / 2 + 1rem))' }}>
          {practices.map((practice) => (
            <div key={practice.id} className="w-[280px] md:w-[300px] flex-shrink-0 group">
              <div className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/60 mb-5">
                {practice.featured && (
                  <div className="px-5 pt-5">
                    <span className="inline-block bg-foreground-900 text-background-50 text-xs font-label font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
                      Core Practice
                    </span>
                  </div>
                )}
                <div className="p-5">
                  <div className="w-full rounded-xl overflow-hidden bg-background-200" style={{ aspectRatio: '4/3' }}>
                    <img
                      src={practice.image}
                      alt={practice.label}
                      title={practice.label}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>

              <div className="text-center px-2">
                <h3 className="text-lg md:text-xl font-body font-semibold text-foreground-900 mb-2">
                  {practice.label}
                </h3>
                <p className="text-sm md:text-base text-foreground-500 font-body leading-relaxed">
                  {practice.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}